import { useQuery } from '@tanstack/react-query'

import { api } from '@/api/client'
import type { FeatureFlag, FeatureFlagKey } from '@/types/featureFlags'

export const featureFlagKeys = {
  all: ['feature-flags'] as const,
}

export const featureFlagsApi = {
  list: () => api.get<FeatureFlag[]>('/api/feature-flags'),

  set: (key: FeatureFlagKey, isEnabled: boolean, resetToDefault = false) =>
    api.put<void>(`/api/feature-flags/${key}`, { isEnabled, resetToDefault }),
}

/**
 * Om et flag er slået til for den aktive organisation.
 *
 * Returnerer `false`, mens listen hentes. Det er den rigtige vej at tage fejl
 * på: en knap, der først dukker op, er til at leve med — en knap, der forsvinder
 * igen, ser ud som en fejl.
 */
export function useFeatureFlag(key: FeatureFlagKey): { isEnabled: boolean; isLoading: boolean } {
  const query = useQuery({
    queryKey: featureFlagKeys.all,
    queryFn: featureFlagsApi.list,
    // Flag skifter sjældent, og listen hentes af hver side, der spørger.
    staleTime: 5 * 60 * 1000,
  })

  return {
    isEnabled: query.data?.find((flag) => flag.key === key)?.isEnabled ?? false,
    isLoading: query.isLoading,
  }
}
